module.exports = __webpack_public_path__ + "static/media/PoissonsBackground.6e59d23f.jpg";